import { ComponentProps, forwardRef, ReactNode, useId } from 'react';
import { useFormContext } from 'react-hook-form';
import clsx from 'clsx';

import styles from './Checkbox.module.css';

interface CustomCheckboxProps extends ComponentProps<'input'> {
  name: string;
  checked?: boolean;
  label?: ReactNode;
  error?: ReactNode;
  required?: boolean;
}

const Checkbox = forwardRef<HTMLInputElement, CustomCheckboxProps>(function CustomCheckbox(
  { label, error, required, className, disabled, checked, name, ...props },
  ref,
) {
  const { register } = useFormContext();
  const inputProps = register(name);

  const id = useId();

  return (
    <>
      <div className={clsx(styles.wrapper, className, error && styles.error, disabled && styles.disabled)}>
        <input
          type="checkbox"
          {...props}
          {...inputProps}
          ref={ref}
          id={id}
          className={styles.input}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
          disabled={disabled}
        />
        {label && (
          <label
            className={styles.label}
            id={`${id}-label`}
            htmlFor={id}
          >
            {label}
          </label>
        )}
      </div>
      {error && (
        <span
          id={`${id}-error`}
          className={styles.errorLabel}
        >
          {error}
        </span>
      )}
    </>
  );
});

export default Checkbox;
